module.exports = __webpack_public_path__ + "static/media/dropdown_icon.488fcfec.svg";